import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16.36 18"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.73 10.97c-.9 0-1.7.47-2.16 1.17L6.04 9.87c.1-.27.16-.56.16-.87 0-.31-.06-.6-.16-.88l4.54-2.27c.46.71 1.26 1.18 2.17 1.18a2.59 2.59 0 0 0 0-5.18 2.578 2.578 0 0 0-2.59 2.59c0 .31.06.6.16.87L5.77 7.58a2.555 2.555 0 0 0-2.16-1.17 2.59 2.59 0 0 0 0 5.18c.91 0 1.7-.47 2.16-1.17l4.53 2.26c-.1.28-.17.57-.17.88a2.59 2.59 0 0 0 5.18 0 2.576 2.576 0 0 0-2.58-2.59zm-1.4-7.93c.38-.38.88-.59 1.42-.59 1.1 0 1.99.89 1.99 1.99s-.89 1.99-1.99 1.99-1.99-.89-1.99-1.99c0-.53.2-1.02.57-1.4zm-7.72 7.95c-1.1 0-1.99-.89-1.99-1.99s.89-1.99 1.99-1.99S5.6 7.9 5.6 9s-.89 1.99-1.99 1.99zm9.12 4.56c-1.1 0-1.99-.89-1.99-1.99s.89-1.99 1.99-1.99 1.99.89 1.99 1.99-.89 1.99-1.99 1.99z"
    }, null, -1)
  ])))
}
export default { render };